<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        stroke-width="1"
        class="ls-icon ls-icon-local-pharm-advisor-icon"
    >
        <path
            fill="currentColor"
            d="M9.227 12.083a.843.843 0 00-1.008-.63 9.42 9.42 0 00-6.271 4.474.843.843 0 001.46.843 7.7 7.7 0 015.189-3.68.843.843 0 00.63-1.007m5.467 7.671c.182-.944.215-1.91.096-2.864a12 12 0 00-1.287-4.022c2.237-.1 6.273-.854 8.548-4.795a.842.842 0 00-1.46-.843c-2.275 3.941-6.792 4.029-8.124 3.96-.49-.787-.882-1.63-1.167-2.513l1.963 1.134a.843.843 0 00.843-1.46L10.86 6.476c-.038-.63 0-1.26.113-1.88l6.166 3.56a.843.843 0 00.843-1.46l-6.524-3.767q.165-.389.377-.755a.843.843 0 00-1.46-.843c-3.189 5.525.782 10.95.953 11.176a10.9 10.9 0 011.379 2.82l-1.97-1.138a.842.842 0 10-.843 1.46l3.233 1.867c.04.629.002 1.26-.113 1.88L6.86 15.844a.842.842 0 00-.843 1.46l6.524 3.767a7 7 0 01-.377.755.842.842 0 001.46.843 9 9 0 00.761-1.691q.204-.6.308-1.224"
        />
    </svg>
</template>
